import React from 'react';

import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChipSize} from 'ui-library/chips/Chip';
import {ChipPopoverInfoField} from 'ui-library/chips/ChipPopoverContent';
import ProcessTaskChip from 'ui-library/chips/ProcessTaskChip';

import {GetChipPopoverContentsArgs} from '../ChipUtilConstants';
import {getProcedureChipPopoverFields, getProcedureTemplateField} from '../procedures/getCommonFields';
import getProcedureStepChipPopoverContents, {
  extractStepExecutionInfo,
} from '../procedures/getProcedureStepChipPopoverContents';

export default function getRecipeStepChipPopoverContents({
  processTask,
  icon,
}: GetChipPopoverContentsArgs): Array<ChipPopoverInfoField> {
  const stepExecutionInstance = processTask.procedureStepExecutionInstance;

  const {conditionReplicateRunTaskId, methodTaskComponent, methodExecutionInstance} =
    extractStepExecutionInfo(stepExecutionInstance);
  const procedureChipPopoverFields = getProcedureChipPopoverFields();
  return getProcedureStepChipPopoverContents({
    processTask,
    icon,
    runPopoverField: {
      label: procedureChipPopoverFields.RECIPE_CONDITION_REPLICATE_RUN,
      value:
        conditionReplicateRunTaskId != null ? (
          <ProcessTaskChip id={conditionReplicateRunTaskId} size={ChipSize.MINI} />
        ) : null,
    },
    unitOpPopoverField: {
      label: procedureChipPopoverFields.RECIPE_UNIT_OPERATION,
      value: methodTaskComponent,
    },
    procedureTemplatePopoverField: getProcedureTemplateField(
      methodExecutionInstance?.procedureRun ?? null,
      ProcessClientOrigin.RECIPES
    ),
  });
}
